<template>
  <div v-if="!settingsGpsDisabled && hasGpsProblem" class="text-center">
    <v-btn icon :class="{'gps-denied': isGpsDenied}" @click="showGpsProblemDialog">
      <v-icon :color="isGpsDenied ? 'red' : 'amber'">{{ isGpsDenied ? 'mdi-crosshairs-off' : 'mdi-crosshairs-question' }}</v-icon>
    </v-btn>
    <HLConfirm v-model="gpsDialog" v-bind="gpsDialogOptions"/>
  </div>
</template>

<script>
    import {eventMixin} from '@/utils/event-mixin'
    import {geolocationMixin} from '@/utils/geolocation-mixin'
    import HLConfirm from '@/components/ui/HLConfirm.vue'

    export default {
        mixins: [eventMixin, geolocationMixin],
        components: {
          HLConfirm
        },
    }
</script>

<style scoped>
.gps-denied{
	border-radius: 50%;
	box-shadow: 0 0 0 0 rgb(248, 80, 58);
	transform: scale(1);
	animation: pulse-red 2s infinite;
}

@keyframes pulse-red {
	0% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(248, 80, 58, 0.7);
	}

	70% {
		transform: scale(1);
		box-shadow: 0 0 0 10px rgba(248, 80, 58, 0);
	}

	100% {
		transform: scale(0.95);
		box-shadow: 0 0 0 0 rgba(248, 80, 58, 0);
	}
}
</style>
